import { editorLoadingState } from '@/stores/editorStore';
import { useRecoilValue } from 'recoil';

export const useImageEnhanceResult = () => {
  const isLoading = useRecoilValue(editorLoadingState);
  return { isLoading };
};
